import { maxLength, required } from "@/locale/locale.config";
import { helpers } from "@vuelidate/validators";

export const timeValidator = (value: string) => {
  const hour24FormatRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return hour24FormatRegex.test(value);
};

const finalDateGreater = (form) => {
  return (value) => {
    return value >= form.startDate;
  };
};

const timeGreaterThanStart = (form) => {
  return (value) => {
    if (!form.finalHour || !form.finalDate) return true;
    const [inputFinalHour, inputFinalMinutes] = value.split(":");
    const date = new Date();
    const finalDate = new Date(form.finalDate);
    finalDate.setHours(inputFinalHour, inputFinalMinutes);
    return finalDate > date;
  };
};

export function validations(form) {
  return {
    classroomId: { required },
    title: { required },
    description: { required, max: maxLength(999) },
    startDate: { required },
    finalDate: {
      required,
      finalDate: helpers.withMessage(
        "O prazo final deve ser uma data posterior à data de início. ",
        finalDateGreater(form)
      ),
    },
    finalHour: {
      required,
      validTime: helpers.withMessage(
        "Por favor, insira um horário válido (00:00 - 23:59)",
        timeValidator
      ),
      greaterThanStart: helpers.withMessage(
        "A hora final deve ser posterior à hora de início.",
        timeGreaterThanStart(form)
      ),
    },
    scoreRange: { required },
  };
}
